var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"content__text",class:_vm.addClass},[_vm._v(" "+_vm._s(_vm.str)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }